export const isSameDomain = (url) => {
    if (url === '') {
        return false;
    }
    try {
        return new URL(url).hostname === window.location.hostname;
        // eslint-disable-next-line no-unused-vars
    }
    catch (error) {
        return false;
    }
};
